import { render } from "./TimeBasedMessage.vue?vue&type=template&id=3a5efb97"
import script from "./TimeBasedMessage.vue?vue&type=script&lang=js"
export * from "./TimeBasedMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__